$('.see-more').click(function() {
  $('.full-description').slideDown();
  $('.short-description').hide();
  $('.see-more').hide();
  $('.see-less').show();
});

$('.see-less').click(function() {
  $('.full-description').slideUp();
  $('.short-description').show();
  $('.see-more').show();
  $('.see-less').hide();
});


$('.product__group-select-item').click(function (event) {

  $('.product__group-select-item').removeClass('active');
  $(this).addClass('active');

 $('.product__group-select-item-title').removeClass('property-value');
  
  $(this).find('.product__group-select-item-title').addClass('property-value');


  var pro_val = $(this).find('.product__group-select-item-title').text();

   pro_val = pro_val.replace(/\s/g, '');
    
  
  console.log('iii'+pro_val);


  $('.product__variants-flavours-item-box').addClass('hide_flavor');

 $('.klaviyo-backinstock').addClass('hide_flavor');

  $('.custom-variant-option-'+pro_val).removeClass('hide_flavor');
  
  $('#formaat_id').val(pro_val);


   $('.product__variants-flavours-item-box').removeClass('active');
   $('.klaviyo-backinstock').removeClass('active');

  $('.custom-variant-option-'+pro_val).first().addClass("active");

  var current_id = $('.custom-variant-option-'+pro_val).first().data("id");

  $('.shopify-product-form').find('[name="id"]').val(current_id);


  var current_url = $('.custom-variant-option-'+pro_val).first().data("url");

 // window.location = 'https://crbnnutrition.com'+ current_url;

   window.history.replaceState({}, "", 'https://crbnnutrition.com'+ current_url);
  
 var price_list =  $('#custom-variant-price-list-'+current_id).html();  

  $('.product-info__price .rating-with-text').empty();

  $('.product-info__price .rating-with-text').html(price_list);

  if($('.custom-variant-option-'+pro_val).first().hasClass('variant_available'))
  {
  $('.buy-buttons').empty();
   $('.buy-buttons').html('<button type="submit" class="button button--xl" style="--button-background: 0 0 0 / var(--button-background-opacity, 1);--button-outline-color: 0 0 0;--button-text-color: 255 255 255;" is="custom-button"><div>Toevoegen aan winkelwagen</div><span class="button__loader"> <span></span> <span></span> <span></span> </span></button>')
  } 
  else
  {
     $('.buy-buttons').empty();
     $('.buy-buttons').html('<button type="submit" class="button button--xl button--subdued" style="--button-background: 0 0 0 / var(--button-background-opacity, 1);--button-outline-color: 0 0 0;--button-text-color: 255 255 255;" is="custom-button" disabled=""><div>Uitverkocht</div><span class="button__loader"> <span></span> <span></span> <span></span> </span></button>')
 
  }  
  
 })

document.querySelectorAll('.faq-question').forEach(item => {
  item.addEventListener('click', () => {
    const answer = item.nextElementSibling;
    const isOpen = answer.style.display === 'block';
    
    // Toggle the clicked one
    answer.style.display = isOpen ? 'none' : 'block';
    item.querySelector('span:last-child').textContent = isOpen ? '+' : '-';
  });
});



$(document).ready(function() {

  $('.product__variant-selects-btn--minus').on('click', function() {

    var m = this;
     
    var qty_val = $(this).next('.product__variant-selects-input').val();

    var product_id = $(this).next('.product__variant-selects-input').data("id");

    $('#product__variant-selects-'+ product_id).addClass('product__variant-selects--loading');
    
    var currentValue = parseInt(qty_val);

    var new_val = currentValue - 1;
   
    $(this).next('.product__variant-selects-input').val(new_val);

    var data = 'id='+ product_id + '&quantity='+ new_val
     
    removeProduct(m, data, product_id, new_val)  

    
    
  });
  
  $('.product__variant-selects-btn--plus').on('click', function() {

    var m = this;
  
    $(m).addClass('product__variant-selects--loading')

    var qty_val =  $(this).prev('.product__variant-selects-input').val();

    var product_id = $(this).prev('.product__variant-selects-input').data("id");


    $('#product__variant-selects-'+ product_id).addClass('product__variant-selects--loading');
    
    var currentValue = parseInt(qty_val);

    var new_val = currentValue + 1;
    
    
    $(this).prev('.product__variant-selects-input').val(new_val);

    var data = 'id='+ product_id + '&quantity='+ new_val

    if($(m).hasClass("variant-btn--plus-cart")){

      removeProduct(m, data, product_id, new_val) 
    }
    else
    {
        addProduct(m, data , product_id) 
    }  
    
  

    
    
  });
});

jQuery('body').on('change paste keyup','.quantity-input',function(){
  
 

  var qty = $(this).val();

  var product_id = $(this).data("id");

    console.log("val:"+qty+"-id-"+ product_id); 

   $('#product__variant-selects-input-'+product_id).val(qty); 
  
})

jQuery('body').on('click','.cart-item-remove',function(){
  
    var product_id = $(this).data("id");

   // console.log(id-"+ product_id); 

   $('#product__variant-selects-input-'+product_id).val(1); 

   $('#xo-variant-button-add-cart-'+product_id).removeClass('hide');
   $('#product__variant-selects-'+product_id).removeClass('active'); 
})


 $('.xo-variant-button-add-cart').click(function (event) {
  
    var m = this;
  
    $(m).addClass('product__variant-selects--loading')
  
    var product_id = $(m).data("id");

    var  pro_val = $('.property-value').data('value');
  
     console.log('swatch id:'+ product_id)
  
      var data = 'id='+ product_id + '&quantity=1'
    
    addProduct(m, data , product_id)
  
  });


function addProduct(m, data , pid) {

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function () {

        
        $.getJSON('/cart.js', function(cart) {

          if(cart.item_count > 0)
          {  
            $('.count-bubble').css({'opacity': '1'});
          $('.count-bubble').text(cart.item_count);

           let total_price = (cart.total_price / 100).toFixed(2);
            $('.cart_tot_price').html('<span class="transcy-money">€'+total_price +'</span>'); 
            
           let items = cart.items;

            let item_qty = 0;
            
            for(var i = 0; i < items.length; i++){
            if (items[i].variant_id == pid){
            item_qty = items[i].quantity;

              break;
            }
            }

            if (item_qty > 0) {
            
            $('.toast-flavour-quantity-value-'+ pid).text(item_qty);

            $('.toast-flavour__variant--'+pid).removeClass('toast-flavour__variant--none');
          setTimeout(
          function() 
          {
           $('.toast-flavour__variant--'+pid).addClass('toast-flavour__variant--none');
            
          }, 5000);

        }
            
          }
          else
          {
             $('.count-bubble').css({'opacity': '0'})
          }  
        })

         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));

        
       $('.product__variant-selects').removeClass('product__variant-selects--loading'); 
        
        $(m).removeClass('product__variant-selects--loading');

         $(m).addClass('hide');
         $(m).next('.product__variant-selects').addClass('active');
      },
      error: function () {
        alert('Fail to Add Swatch')
      }
      });
  
}

function removeProduct(m, data, id , qty) {

   $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: data,
      success: function (event) {

             

        $.getJSON('/cart.js', function(cart) {

          if(cart.item_count > 0)
          {  
 
            
            
            $('.count-bubble').css({'opacity': '1'})
          $('.count-bubble').text(cart.item_count);

            let items = cart.items;

            let item_qty = 0;
            
            for(var i = 0; i < items.length; i++){
            if (items[i].variant_id == id){
            item_qty = items[i].quantity;

              break;
            }
            }

            $('.toast-flavour-quantity-value-'+ id).text(item_qty);

          if (item_qty > 0) {            

          $('.toast-flavour__variant--'+id).removeClass('toast-flavour__variant--none');
          setTimeout(
          function() 
          {
           $('.toast-flavour__variant--'+id).addClass('toast-flavour__variant--none');
            
          }, 6000); 

           }  
            
          }
        })


         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
        
      

       $('.product__variant-selects').removeClass('product__variant-selects--loading'); 

       $('.product__variant-selects-btn--plus').removeClass('product__variant-selects--loading');  
        
        console.log('qty:'+ qty);
        
        if (qty == 0) {
        
        $('#xo-variant-button-add-cart-'+id).removeClass('hide');
        $('#product__variant-selects-'+id).removeClass('active');

        $('#product__variant-selects-input-'+id).val(1);  
          
        } 
        
      },
      error: function (event) {
        alert('Fail to remove Swatch')
      }
      });
}


/* change images on variant option selection */


 $('.product__variants-flavours-item, .klaviyo-backinstock').click(function (event) {


     
   $('.product__variants-flavours-item').removeClass('active');
   $('.klaviyo-backinstock').removeClass('active');

   $(this).addClass('active');

   var product_id = $(this).data('id');


    $('.shopify-product-form').find('[name="id"]').val(product_id);


   var price_list =  $('#custom-variant-price-list-'+product_id).html();  

   console.log('fff'+ price_list);

  $('.product-info__price .rating-with-text').empty();

  $('.product-info__price .rating-with-text').html(price_list);


  var current_url = $(this).data("url");

 // window.location = 'https://crbnnutrition.com'+ current_url;

 //  window.history.replaceState({}, "", 'https://crbnnutrition.com'+ current_url);

  if($(this).hasClass('variant_available'))
  {
  $('.buy-buttons').empty();
   $('.buy-buttons').html('<button type="submit" class="button button--xl" style="--button-background: 0 0 0 / var(--button-background-opacity, 1);--button-outline-color: 0 0 0;--button-text-color: 255 255 255;" is="custom-button"><div>Toevoegen aan winkelwagen</div><span class="button__loader"> <span></span> <span></span> <span></span> </span></button>')
  } 
  else
  {
     $('.buy-buttons').empty();
     $('.buy-buttons').html('<button type="submit" class="button button--xl button--subdued" style="--button-background: 0 0 0 / var(--button-background-opacity, 1);--button-outline-color: 0 0 0;--button-text-color: 255 255 255;" is="custom-button" disabled=""><div>Uitverkocht</div><span class="button__loader"> <span></span> <span></span> <span></span> </span></button>')
 
  }  


   
 setTimeout(function(){
     
   for (var i=1; i < 11; i++) {

   var img_src =  $("#custom-variant-img-"+ product_id +"-"+i).val();

     console.log('img src:'+ img_src)
     
     if (img_src != null || img_src != undefined ) 
     {

     $('#product-gallery-'+i).find('img').attr('src', img_src);
     $('#product-gallery-'+i).find('img').attr('srcset', img_src);
     }
     else
     {
       return false;
     }  
     
    $('#product').val('test');
  }

    }, 10);
   
 })



jQuery('body').on('click','.size-element-content label',function(){


  var title = $(this).find('span').text();
  
  console.log('ggg hh hh hhd'+ title)
  
})
